module.exports = __webpack_public_path__ + "static/media/stripe_visa.8434daa4.svg";